var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["cascade-picker-page"]},[_c('div',{class:["btn-item"]},[_c('basic-picker')],1),_c('div',{class:["btn-item"]},[_c('async-picker')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }